import React from 'react'
import * as Style from './style'

export default () => {
  return (
    <div>
      <div className={Style.bgContainer}>
        <div>
          <div className={Style.title}>Presentation Finished</div>
          <div className={Style.description}>Thank you</div>
        </div>
      </div>
    </div>
  )
}
